let ENV = process.env.VUE_APP_CURRENTMODE; //获取环境变量
let webSocketUrl = '';
let mobileSignUrl = '';
let currentUrl = "";
let socketIo = "";
let lookCeryificateUrl = "";
let isHttps = false;
switch (ENV) {
  case 'testing':
    webSocketUrl = 'wss://fq.gz-notary.com';
    //手绘签名的地址
    mobileSignUrl = "https://gzfq_fq_test.ip360.org";
    // mobileSignUrl = "http://192.168.50.27:19060";
    currentUrl = "https://gzfq_fq_test.ip360.org";
    socketIo = "wss://gzfq_fq_test.ip360.org";
    lookCeryificateUrl = "https://gzfq_cz_test.ip360.org";
    break;
  case 'preview':
    webSocketUrl = 'ws://10.8.1.44:8080';
    mobileSignUrl = "http://m.xcontract.cn";
    currentUrl = "http://www.xcontract.cn";
    socketIo = "ws://47.94.74.150:50001";
    lookCeryificateUrl = "https://bq.gz-notary.com";
    break;
  case 'product':
    webSocketUrl = 'wss://fq.gz-notary.com';
    mobileSignUrl = "https://fq.gz-notary.com";
    currentUrl = "https://fq.gz-notary.com";
    socketIo = "wss://fq.gz-notary.com";
    lookCeryificateUrl = "https://bq.gz-notary.com";
    isHttps = true;
    break;
  case 'advance':
    console.log('本地启动预发环境')
    break;
  case 'hangzhou':
    webSocketUrl = 'wss://demo.yibee.com:9080/xcon/webapi';
    //手绘签名的地址
    mobileSignUrl = "http://47.111.104.83:8001";
    // mobileSignUrl = "http://192.168.50.27:19060";
    currentUrl = "http://47.111.104.83:8000";
    socketIo = "wss://demo.yibee.com:9080/xcon/webapi";
    lookCeryificateUrl = "https://gzfq_cz_test.ip360.org";
    break;
  default:
    webSocketUrl = 'wss://fq.gz-notary.com';
    mobileSignUrl = "https://fq.gz-notary.com";
    currentUrl = "https://fq.gz-notary.com";
    socketIo = "wss://fq.gz-notary.com";
    lookCeryificateUrl = "https://gzfq_cz_test.ip360.org";
}
let GlobalConfig = {
  webSocketUrl: webSocketUrl,
  mobileSignUrl: mobileSignUrl,
  currentUrl: currentUrl,
  socketIo: socketIo,
  isHttps: isHttps,
  ENV: ENV,
  lookCeryificateUrl: lookCeryificateUrl
}
export default GlobalConfig;